var aulaComment = {  
	configs : {
		channelName: '',
		eventName: 'questionMessage',
		eventNameComment: 'questionComment'
	},
	setConfigs :function(){ 
		aulaComment.configs.channelName = 'quetion' + og.params.channelName
	},
	sendQestion: function(){
		$("#idFormQuestion").validate({ 
			rules: {
				qestiontext: {   
					required: true 
				}
			}, 
			messages: {
				qestionText: {
					required: "Por favor ingrese su comentario"
				}
			},
			errorPlacement: function(error, element) {
				//error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
			 },
			submitHandler: function(form) {
				var params = og.params; 
				 params.qestiontext = $('#qestiontext').val();
				 params.channel = aulaComment.configs.channelName;
				 $("#enviarP").addClass('btn-disable');
				 console.log(params);
				 if($('#qestiontext').val() == ''){ 
				 	
				 }else{
				 	$.ajax({
						url : '/es/class-room/save-comment', 
						type : 'POST',
						dataType : 'json',
						data : params,
						success : function(data) {
							$("#enviarP").removeClass('btn-disable');
							//console.log('Prueba: '+data.id);
							//aulaComment.renderQuestionCommentFirst(data.id);
							//aulaComment.renderQuestion(data, false);
						}  
					})
				 }
			}
		});
	 },
	 sendComment: function(idQuestion){
		var params = og.params; 
		params.commenttext = $('#commenttext'+idQuestion).val();
		params.channel = aulaComment.configs.channelName;
		params.idQuestion = idQuestion;
		params.partnerId = og.params.partnerId;
		$.ajax({
			url : '/es/class-room/save-comment-comment', 
			type : 'POST',
			dataType : 'json',
			data : params,
			success : function(data) {  
				//aulaComment.getQuestionComment(data, false, data.questionId);
				$("#comment-form-reply").remove();
			} 
		});
	 },
	 getQuestions : function(partnerId, classId, pageNum) { 

		 $.ajax({
			url : '/es/class-room/comment', 
			type : 'GET',
			dataType : 'json',
			data : {id : classId, page: pageNum, partnerId: partnerId},
			beforeSend:function(result) {
				$('#idQuestionContent').append('<div id="loading" style="text-align:center;" ><span class="ld"> Cargando.... </span></div>');
			},
			success : function(result){
				if(result.success){
				  $.each( result.data, function( index, questionRow ){
					aulaComment.renderQuestion(questionRow, true);
				  });
				}
				$('#loading').html('');
			} 
		})
	 },
	 renderQuestion : function(questionRow, load) {
		var item = $('<li class="comment-item"></li>');
		/*var commentForm = '<div id="form-comment" class="fluid-list cnt-form-msg cnt-second-msg">'+
							'<textarea class="form-control" id="commenttext'+questionRow.id+'" name="msg" rows="2" maxlength="200"></textarea>'+
							'<div class="form-group">'+
								'<button onclick="aulaComment.sendComment('+questionRow.id+')" type="submit" class="btn btn-default btn-msg">Responder</button>'+
							'</div>'+
						'</div>';*/
		var commentForm = '<div id="comment-form-reply">'+
                            '<form class="comment-reply-form">'+
                                '<textarea id="commenttext'+questionRow.id+'" name="msg" rows="2" maxlength="200" class="form-control"></textarea>'+
                                '<button type="button" onclick="aulaComment.sendComment('+questionRow.id+')" class="btn-l-reply">Enviar</button>'+
                            '</form>'+
                        '</div>';
		item.attr('data-question-id', questionRow.id);
		item.attr('id', 'questionId' + questionRow.id);
		/*var questionTxt = ''+
				'<div class="f-perfil">'+
					'<a href="'+questionRow.uri+'" target="back" style="height: 50px;width: 50px;background: url('+questionRow.user.icon+') no-repeat;background-size: cover;background-position: center center;border-radius: 50%;display:block;">'+
						'<img alt="" style="width: 60px;display:none;" class="img-circle" src="'+questionRow.user.icon+'">'+
					'</a>'+
			    '</div>'+ 
			    '<div class="fluid-list cnt-form-msg">'+
			    	'<a href="'+questionRow.uri+'" target="back">'+
			        	'<h4>'+questionRow.user.name.replace(/\\('|&quot;)/g, '$1')+'</h4>'+
		        	'</a>'+
			        '<p>'+questionRow.body.replace(/\\('|&quot;)/g, '$1')+'</p>'+
			        '<div class="fluid-list cnt-like">'+
                        '<a href="#" class="ico-like-l"><span class="glyphicon glyphicon-hand-right" aria-hidden="true"></span></a>'+ 
			        	'<span class="count-like-l">02</span> <span><a class="responce-form" href="#">Responder</a></span> <span>'+aula.timeToDescription(questionRow.published)+'</span>'+
                    '</div>'+
			    '</div>';*/
		var questionTxt = ''+
				'<div class="clear-fix block-comment-i">'+
                        '<figure style="background:url('+questionRow.user.icon+') no-repeat;background-size:cover;background-position:center center;">'+
                            '<img src="'+questionRow.user.icon+'" alt="">'+
                        '</figure>'+
                        '<div class="clear-fix right-comment">'+
                            '<span>'+aula.timeToDescription(questionRow.published)+'</span>'+
                            '<h3><a href="'+questionRow.uri+'">'+questionRow.user.name.replace(/\\('|&quot;)/g, '$1')+'</a></h3>'+
                            '<p>'+questionRow.body.replace(/\\('|&quot;)/g, '$1')+'</p>'+
                            '<a href="#" class="active-comment right">Responder</a>'+
                        '</div>'+
                    '</div>';
		item.append(questionTxt);
		if(load){
			$('#idQuestionContent').append(item);
		} else {
			$('#idQuestionContent').prepend(item);
		}
		$("#questionId"+questionRow.id+" .active-comment").click(function(e){
			e.preventDefault();
			$("#comment-form-reply").remove();
			item.find('.block-comment-i').find('.active-comment').remove();
			item.find('.block-comment-i').find('.right-comment').append(commentForm);
		});
		//comentarios
		aulaComment.renderQuestionComment(questionRow.id);
		if( !jQuery.isEmptyObject(questionRow.comments) ) {
			$.each( questionRow.comments, function( i, comment ){
				aulaComment.getQuestionComment(comment, load, questionRow.id);
			});
		}
		$('#qestiontext').val(''); 
	 },
	 getQuestionComment : function(commentRow, load, questionId) {
		var commentForm = '<div id="comment-form-reply">'+
                            '<form class="comment-reply-form">'+
                                '<textarea id="commenttext'+questionId+'" name="msg" rows="2" maxlength="200" class="form-control"></textarea>'+
                                '<button type="button" onclick="aulaComment.sendComment('+questionId+')" class="btn-l-reply">Responder</button>'+
                            '</form>'+
                        '</div>';
		/*var contentComment = ''+
		 		'<div id="subsecond'+commentRow.id+'" class="fluid-list p-list-msg-i">'+
					'<div class="f-perfil">'+
						'<a href="'+commentRow.uri+'" target="back" style="height: 50px;width: 50px;background: url('+commentRow.user.icon+') no-repeat;background-size: cover;background-position: center center;border-radius: 50%;display:block;">'+
							'<img alt="" style="width: 60px;display:none;" src="'+commentRow.user.icon+'">'+
						'</a>'+
				    '</div>'+
				    '<div class="fluid-list cnt-form-msg">'+
				    	'<a href="'+commentRow.uri+'" target="back">'+
				        	'<h4>'+commentRow.user.name.replace(/\\('|&quot;)/g, '$1')+'</h4>'+
			        	'</a>'+
				        '<p>'+commentRow.body.replace(/\\('|&quot;)/g, '$1')+'</p>'+
				        '<div class="fluid-list cnt-like">'+
							'<a href="#" class="ico-like-l"><span class="glyphicon glyphicon-hand-right" aria-hidden="true"></span></a> <span class="count-like-l">02</span> '+aula.timeToDescription(commentRow.published)+// 02 <span>Hace 1 Minutos</span>'+
						'</div>'+
				    '</div>'+
			    '</div>';*/
		var contentComment = ''+
				'<li id="subsecond'+commentRow.id+'" class="comment-item comment-reply">'+
                    '<div class="clear-fix block-comment-i">'+
                        '<figure style="background:url('+commentRow.user.icon+') no-repeat;background-size:cover;background-position:center center;">'+
                            '<img src="'+commentRow.user.icon+'" alt="">'+
                        '</figure>'+
                        '<div class="clear-fix right-comment">'+
                            '<span>'+aula.timeToDescription(commentRow.published)+'</span>'+
                            '<h3><a href="'+commentRow.uri+'">'+commentRow.user.name.replace(/\\('|&quot;)/g, '$1')+'</a></h3>'+
                            '<p>'+commentRow.body.replace(/\\('|&quot;)/g, '$1')+'</p>'+
                        '</div>'+
                    '</div>'+
                '</li>'; 
		if(load){
		 	$('#second'+questionId).append(contentComment);
		} else {
		 	$('#second'+questionId).prepend(contentComment);
		}

		$("#subsecond"+commentRow.id+" .responce-form").click(function(e){
			e.preventDefault();
			$("#comment-form-reply").remove();
			$("#subsecond"+commentRow.id).append(commentForm);
		});
		
	 },
	renderQuestionComment: function(questionId){ 
		var txt = '<div id="second'+questionId+'" class="fluid-list s-list-msg-i esto-es"></div>';
		$('#idQuestionContent').append(txt);
	},
	renderQuestionCommentFirst: function(questionId){ 
		var txt = '<div id="second'+questionId+'" class="fluid-list s-list-msg-i esto-es"></div>';
		$('#idQuestionContent').prepend(txt);
	},
	getChanel: function() {
		pusher = new Pusher(og.params.key)
		var channel = pusher.subscribe(aulaComment.configs.channelName);
		channel.bind(aulaComment.configs.eventName, function(data) {
			aulaComment.renderQuestion(data, false);
		});
		 //commentEvent
		channel.bind(aulaComment.configs.eventNameComment, function(data) {
			aulaComment.getQuestionComment(data, false, data.questionId);
		});
	}
}

